// extracted by mini-css-extract-plugin
module.exports = {"main-wrapper":"GoldTransaction_main-wrapper__3M50Y"};